export default {"src":"/_next/static/media/xbp.69a88a5b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};